import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import {
  ButtonVariant,
  ButtonType,
  CustomButton,
} from '../../atoms/CustomButton';
import ArrowLeft from '../../assets/ArrowLeft.svg';
import InputField from '../../atoms/InputField';
import { scaleByRatio } from '../../utils/helper';
import AppLogoMin from '../../assets/AppLogoMin.svg';

const ProfileWorkData = ({
  questionText,
  answerType,
  onBackClicked,
  handleOnNextClicked,
  error,
  answer = '120',
  showBackButton = true,
  btnSubmitText = 'Next',
  showAppIcon = true,
}) => {
  const [workData, setWorkData] = useState();

  const [workError, setWorkError] = useState(error);

  const handleWorkData = (e) => {
    console.log('work_data: ', e.target.value);
    let work_data = e.target.value;
    setWorkData(work_data);
  };
  const onNextClicked = () => {
    console.log('onNextClicked ', workData);

    if (!workData) {
      setWorkError('Please provide input.');
      return;
    } else {
      handleOnNextClicked(workData);
    }
  };

  console.log('workError', workError);
  useEffect(() => {
    if (workData) {
      setWorkError('');
    }
  }, [workData]);

  return (
    <>
      {showAppIcon && (
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="flex-end">
          <Grid item className={styles.logoContainer} marginTop={-8}>
            {/* <Typography textAlign='center' className={styles.logoContainer}> */}
            <img
              src={AppLogoMin}
              alt={'App icon'}
              className={styles.logo}
              style={{
                width: `90%`,
                marginBottom:'40px',
                height: `${scaleByRatio(110)}px`,
              }}
            />
            {/* </Typography> */}
          </Grid>
        </Grid>
      )}
      {showBackButton && (
        <Grid
          container
          direction="row"
          justifyContent="left"
          alignItems="">
          <Grid item className={styles.logoContainer}>
            <img
              src={ArrowLeft}
              alt={'Back icon'}
              className={styles.logoback}
              onClick={onBackClicked}
              width={scaleByRatio(12)}
              height={scaleByRatio(12)}
            />
          </Grid>
          <Grid item>
            <Typography
              textAlign="left"
              className={styles.back}
              onClick={onBackClicked}
              style={{
                fontSize: `${scaleByRatio(12)}px`,
                paddingLeft: `${scaleByRatio(10)}px`,
                paddingBottom: `${scaleByRatio(1)}px`,
              }}>
              Back
            </Typography>
          </Grid>
        </Grid>
      )}
      <Grid
        container
        direction="row"
        justifyContent="left"
        alignItems="flex-end">
        <Grid item>
          <Typography
            textAlign="left"
            className={styles.description}
            style={{
              fontSize: `${scaleByRatio(22)}px`,
              lineHeight: `${scaleByRatio(28.64)}px`,
              letterSpacing: '0.06em', 
              marginLeft: '15px'
            }}>
            {questionText}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="left"
        alignItems="flex-end">
        <Grid item xs={12} style={{ paddingRight: '5px' }}>
          <InputField
            id={'workData'}
            type={'text-field'}
            value={workData}
            handleChange={handleWorkData}
            placeholder={'Security'}
            labelId={''}
            minHeightPX="100"
            multiline={true}
            rows={4}
            class_name={styles.name}
          />
        </Grid>
      </Grid>
      {workError && workError?.length > 0 && (
        <Grid
          container
          direction="row"
          justifyContent="left"
          alignItems="flex-end">
          <Typography
            textAlign="left"
            className={styles.error}
            style={{
              fontSize: `${scaleByRatio(12)}px`,
              lineHeight: `${scaleByRatio(40)}px`,
            }}>
            {workError}
          </Typography>
        </Grid>
      )}
      <Grid
        container
        direction="row"
        justifyContent="end"
        alignItems="flex-end">
        <Grid item>
          <CustomButton
            text={btnSubmitText}
            variant={ButtonVariant.contained}
            type={ButtonType.primary}
            onClick={onNextClicked}
            customStyle={`yes`}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ProfileWorkData;
